import 'svelte/internal/disclose-version';

Gate[$.FILENAME] = 'client/Gate.svelte';

import * as $ from 'svelte/internal/client';
import logo from "./assets/logo.png";

var root = $.add_locations(
	$.from_html(
		`

<main class="grid h-screen place-items-center bg-sky">
  <form class="flex flex-col items-center gap-5">
    <img alt="Golden Day" class="w-64 drop-shadow-[0_6px_16px_rgba(0,0,0,.35)]"/>
    <input type="password" placeholder="Mot de passe"/>
    <button class="rounded-full border-[3px] border-ink bg-gold px-6 py-2 font-comic text-2xl tracking-wide shadow-[4px_4px_0_#17150f] transition hover:-translate-y-0.5">Entrer</button>
  </form>
</main>`,
		1
	),
	Gate[$.FILENAME],
	[[11, 0, [[12, 2, [[13, 4], [14, 4], [15, 4]]]]]]
);

function Gate($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, Gate);

	let pw = $.tag($.state(""), 'pw');
	let bad = $.tag($.state(false), 'bad');

	async function go(e) {
		e.preventDefault();

		if ((await $.track_reactivity_loss(fetch("/auth", { method: "POST", body: $.get(pw) })))().ok) {
			localStorage.setItem("gday", "ok");
			location.reload();
		} else $.set(bad, true);
	}

	var $$exports = { ...$.legacy_api() };

	$.next();

	var fragment = root();
	var main = $.sibling($.first_child(fragment));
	var form = $.sibling($.child(main));
	var img = $.sibling($.child(form));
	var input = $.sibling(img, 2);

	$.remove_input_defaults(input);
	$.autofocus(input, true);
	$.next(3);
	$.reset(form);
	$.next();
	$.reset(main);

	$.template_effect(() => {
		$.set_attribute(img, 'src', logo);
		$.set_class(input, 1, `w-64 rounded-full border-[3px] border-ink bg-white px-5 py-2 text-center font-comic text-2xl tracking-wide shadow-[4px_4px_0_#17150f] outline-none ${$.get(bad) ? 'border-orange' : ''}`);
	});

	$.event('submit', form, go);

	$.bind_value(
		input,
		function get() {
			return $.get(pw);
		},
		function set($$value) {
			$.set(pw, $$value);
		}
	);

	$.append($$anchor, fragment);

	return $.pop($$exports);
}

if (import.meta.hot) {
	Gate = $.hmr(Gate);

	import.meta.hot.accept((module) => {
		Gate[$.HMR].update(module.default);
	});
}

export default Gate;